import { FC } from "react";
import {
    Box,
    Text,
    Heading,
    Divider,
    useBreakpointValue,
} from "@smile2impress/components/relaunch";

import { ClinicPageArticleContentProps } from "./ClinicPageArticleContent.types";

export const ClinicPageArticleContent: FC<ClinicPageArticleContentProps> = ({
    content,
}) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });

    return (
        <Box>
            {JSON.parse(content).blocks.map((block: any, index: number) => {
                switch (block.type) {
                    case "header":
                        if (!block.data.text) break;

                        const isH3 = block.data.text.includes("<b>");
                        const text = isH3
                            ? block.data.text.replace(/<[^>]*>/g, "")
                            : block.data.text;

                        return (
                            <Heading
                                key={`header-${index}`}
                                as={
                                    isH3
                                        ? "h3"
                                        : (`h${block.data.level}` as any)
                                }
                                textStyle={isH3 ? "H3" : "caption"}
                                color="text.base"
                                mt={isH3 ? [0, 0, 3] : 0}
                                mb={isH3 ? 2 : 0.7}
                            >
                                {text}
                            </Heading>
                        );
                    case "paragraph":
                        if (block.data.text) {
                            return (
                                <Text
                                    key={`paragraph-${index}`}
                                    textStyle="body"
                                    mb={2}
                                    _last={{ mb: 0 }}
                                >
                                    {block.data.text}
                                </Text>
                            );
                        }

                        if (isMobile && !block.data.text) {
                            return (
                                <Divider
                                    key={`divider-${index}`}
                                    borderColor="secondary.halfBlack"
                                    my={3}
                                />
                            );
                        }

                        break;
                    case "list": {
                        const listData = block.data as {
                            style?: "ordered" | "unordered";
                            items?: string[];
                        };
                        if (!listData?.items?.length) break;

                        const ListTag = (
                            listData.style === "ordered" ? "ol" : "ul"
                        ) as keyof JSX.IntrinsicElements;

                        return (
                            <Box
                                key={`list-${index}`}
                                as={ListTag}
                                mb={1}
                                pl={3}
                            >
                                {listData.items.map((item, i) => (
                                    <Box
                                        key={i}
                                        as="li"
                                        textStyle="body"
                                        color="text.base"
                                        mb={1}
                                        _last={{ mb: 0 }}
                                        dangerouslySetInnerHTML={{
                                            __html: item,
                                        }}
                                    />
                                ))}
                            </Box>
                        );
                    }
                    default:
                        return null;
                }
            })}
        </Box>
    );
};
